var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXianshi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 13,
    height: 9,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_1150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8501 5.99999C4.31069 5.0965 5.01212 4.33794 5.87686 3.80816C6.7416 3.27837 7.73598 2.99799 8.7501 2.99799C9.76422 2.99799 10.7586 3.27837 11.6233 3.80816C12.4881 4.33794 13.1895 5.0965 13.6501 5.99999C13.1895 6.90348 12.4881 7.66203 11.6233 8.19182C10.7586 8.7216 9.76422 9.00199 8.7501 9.00199C7.73598 9.00199 6.7416 8.7216 5.87686 8.19182C5.01212 7.66203 4.31069 6.90348 3.8501 5.99999ZM8.7501 7.99999C9.28053 7.99999 9.78924 7.78927 10.1643 7.4142C10.5394 7.03913 10.7501 6.53042 10.7501 5.99999C10.7501 5.46955 10.5394 4.96085 10.1643 4.58577C9.78924 4.2107 9.28053 3.99999 8.7501 3.99999C8.21966 3.99999 7.71096 4.2107 7.33588 4.58577C6.96081 4.96085 6.7501 5.46955 6.7501 5.99999C6.7501 6.53042 6.96081 7.03913 7.33588 7.4142C7.71096 7.78927 8.21966 7.99999 8.7501 7.99999ZM8.7501 6.99999C8.48488 6.99999 8.23053 6.89463 8.04299 6.70709C7.85545 6.51956 7.7501 6.2652 7.7501 5.99999C7.7501 5.73477 7.85545 5.48042 8.04299 5.29288C8.23053 5.10534 8.48488 4.99999 8.7501 4.99999C9.01531 4.99999 9.26967 5.10534 9.4572 5.29288C9.64474 5.48042 9.7501 5.73477 9.7501 5.99999C9.7501 6.2652 9.64474 6.51956 9.4572 6.70709C9.26967 6.89463 9.01531 6.99999 8.7501 6.99999Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14L8.75 10.5L11.75 14",
    stroke: "black",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3.75 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXianshi);
export default __webpack_public_path__ + "static/media/xianshi.8f44fcf066a13fe234e7e223e84e909f.svg";
export { ForwardRef as ReactComponent };